import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a0f0a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'rgba(212, 175, 55, 0.05)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(212, 175, 55, 0.3)',
        borderRadius: '20px',
        padding: '48px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center'
      }}>
        <XCircle 
          size={64} 
          style={{ 
            color: '#ffa500', 
            margin: '0 auto 24px'
          }} 
        />
        <h2 style={{
          fontSize: '28px',
          fontFamily: 'Cinzel, serif',
          color: '#ffa500',
          marginBottom: '16px'
        }}>
          Payment Cancelled
        </h2>
        <p style={{ color: '#E6D7C3', marginBottom: '32px', lineHeight: '1.6' }}>
          Your payment was cancelled. No charges were made to your account.
        </p>
        
        <button
          onClick={() => navigate(-1)}
          style={{
            width: '100%',
            padding: '16px',
            background: 'linear-gradient(135deg, #D4AF37 0%, #B8941E 100%)',
            border: 'none',
            borderRadius: '12px',
            color: '#1a1a1a',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            marginBottom: '12px',
            fontFamily: 'Cinzel, serif',
            transition: 'transform 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
        >
          Try Again
        </button>
        
        <button
          onClick={() => navigate('/profile')}
          style={{
            width: '100%',
            padding: '16px',
            background: 'rgba(212, 175, 55, 0.1)',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            borderRadius: '12px',
            color: '#D4AF37',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontFamily: 'Cinzel, serif'
          }}
        >
          Return to Profile
        </button>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
